import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './createMatchForm.css';

import React, {useState} from "react";
import DatePicker from 'react-date-picker';

import {
    Container,
    Box,
    Input,
    FormControl,
    InputLabel,
    Button
} from "@mui/material";

import {useTranslate, useAction} from "../../hooks";

const CreateMatchForm = () => {
    const translate = useTranslate()
    const [name, setName] = useState("");
    const [date, setDate] = useState(null);
    const {setName: setMatchName, setDate: setMatchDate, setShowMainView} = useAction()
    const onChangeNameHandler = e => {
        setName(e.target.value.trimLeft())
    };

    const onSubmitHandler = e => {
        e.preventDefault()
        setMatchName({name})
        setMatchDate({date})
        setShowMainView()
    }

    return (
        <Container>
            <Box
                component="form"
                sx={{
                    bgcolor: 'background.paper',
                    boxShadow: 1,
                    borderRadius: 2,
                    p: 2,
                    width: 480,
                    margin: "auto",
                    marginTop: 20
                }}
            >
                <FormControl fullWidth={true}>
                    <InputLabel htmlFor="name">{translate['FORM_CREATE_MATCH_NAME_LABEL']}</InputLabel>
                    <Input
                        name='password'
                        autoComplete='off'
                        type='text'
                        value={name}
                        id="name"
                        color="primary"
                        sx={{
                            fontSize: 16
                        }}
                        onChange={onChangeNameHandler}
                    />
                </FormControl>
                <FormControl fullWidth={true}>
                    <DatePicker
                        value={date}
                        onChange={setDate}
                        format="dd.MM.y"
                        minDate={new Date()}
                    />
                </FormControl>
                <Button
                    fullWidth={true}
                    variant='contained'
                    type="submit"
                    sx={{
                        mt: 4
                    }}
                    onClick={onSubmitHandler}
                >
                    {translate['START']}
                </Button>
            </Box>
        </Container>
    )
};

export default CreateMatchForm